import debugLib from 'debug';

const debug = debugLib('vs3:util:breakpoints');

export default {
  XS: 1,
  SM: 2,
  MD: 3,
  LG: 4,
  XL: 5,
  XXL: 6,
};

export function breakpointToDevice(bp) {
  switch (bp) {
  case 1:
  case 2:
    return 'mobile';
  case 3:
    return 'tabletPortrait';
  case 4:
    return 'tabletLandscape';
  case 5:
  case 6:
    return 'desktop';
  default:
    debug('no matching device was found');
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/util/breakpoints.js